export const cilWindowMaximize = ["24 24","<path d='M22.125 2.25h-20.234c-0.621 0.001-1.124 0.504-1.125 1.125v18c0.001 0.621 0.504 1.124 1.125 1.125h20.234c0.621-0.001 1.124-0.504 1.125-1.125v-18c-0.001-0.621-0.504-1.124-1.125-1.125h-0zM21.75 3.75v3.374l-19.484-0.023v-3.351zM2.266 21v-12.399l19.484 0.023v12.376z'></path>"]


//////////////////
// WEBPACK FOOTER
// ./node_modules/@coreui/icons/js/free/cil-window-maximize.js
// module id = null
// module chunks = 